import ConversationListItem from '@/components/modules/chat/ConversationListItem'
import type { Conversation } from '@/types/chat'

export default function ConversationList({
  conversations,
  conversationId,
  onDelete,
}: {
  conversations: Conversation[]
  conversationId?: string
  onDelete: (id: string) => void
}) {
  if (conversations.length === 0) {
    return (
      <p className="px-3 py-6 text-center text-sm text-muted-foreground">No conversations yet</p>
    )
  }

  return conversations.map((conversation) => (
    <ConversationListItem
      key={conversation.id}
      conversation={conversation}
      isActive={conversationId === conversation.id}
      onDelete={onDelete}
    />
  ))
}
